// extracted by mini-css-extract-plugin
export var scrollArea = "_pq-0";